import { useSyncExternalStore } from 'react';

const PHONE = '(max-width: 639px)';

/** A phone-width screen (below Tailwind's `sm`), re-read when it changes. */
function phoneQuery(): MediaQueryList | null {
  // Test environments may stub `matchMedia` away.
  if (typeof window.matchMedia !== 'function') return null;
  return (window.matchMedia(PHONE) as MediaQueryList | undefined) ?? null;
}

export function usePhone(): boolean {
  return useSyncExternalStore(
    (notify) => {
      const query = phoneQuery();
      query?.addEventListener('change', notify);
      return () => query?.removeEventListener('change', notify);
    },
    () => phoneQuery()?.matches ?? false,
    () => false,
  );
}
